
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`This is brought by the
                    <a href="${0}">Folksonomy Engine project</a>. Don't
                    hesitate to participate or give feedback`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Tresna honek osagaien zerrenda zuzentzeko aukera ematen dizu.
                osagaien zerrenda gehitu, kendu edo editatu dezakezu.
                <br>
                Karaktere honek <span class="highlight">␣</span> hutsune bat adierazten du.
                <br>
                Karaktere honek <span class="highlight">↩︎</span> lerro-jauzi bat adierazten du. `,
'hb28f1f2ec1744ee9': html`These properties are created and filed by users for any kind of usages. Feel
                    free to add your own. The properties and values you create
                    <strong>must be factual</strong>. You can dive into
                    <a href="${0}">the list of properties already used by the community</a>
                    or explore the
                    <a href="${1}">properties' documentation and its search engine</a>.`,
's000a5b76bd3a01c2': `Propietateak kargatzen...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Lagundu iezaguzu osagaiak lortzen`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Balioztatu uzta`,
's03e9c8114521b998': `Osagaiak editatuko ditut.`,
's05ec315d9308091a': `Barra-kodearen izkinen ikonoa`,
's061eb5af92512c85': `Gordeta! Beste batekin lagun al dezakezu?`,
's06847c221c4c0bc1': `[Zure erabilera kasua deskribatzeko] propietate bat sortu nahi nuke...`,
's06f6c6f99db6b552': `Jatorrizkoa`,
's081e2ad82db71e1d': `Balio multzokatuak`,
's09205907b5b56cda': `Ez`,
's0b4235aae602a950': `dokumentazio dedikatua.`,
's0bb2d48532acc455': `Deskargatu CSV`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Irudia baliogabetu`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Utzi mozketa`,
's11a18a69b30b65ed': `Lagundu iezaguzu osagaien zerrendako akatsak konpontzen`,
's1205d5f6fccf8e69': `Jabetzaren balioa`,
's15d64a0a6715285a': `Giltza berria`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Hautapen eremua`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Lagundu iezaguzu nutrizio-informazioa zuzentzen`,
's1e00019dc454872d': `Mesedez, eman propietatearen izena property-name atributua erabiliz.`,
's1e49126af0935a5b': `Propietate hau erabiltzen duten produktuen zerrenda`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Ezeztatu`,
's2db7b654c0a9bde0': `Jabetza dokumentatu.`,
's300b3a6ee4e1252d': str`Bat etortze eskasa ${0}%`,
's33f786bb6b4f0cf4': `Mozketaren emaitza`,
's33f85f24c0f5f008': `Gorde`,
's34be4af4e8fec4ae': `Galdetu lehenik komunitateari`,
's36d86adc823cbfa6': `Jabetza berri bat sortu aurretik, eztabaidatu komunitatearekin:`,
's3781d25aa51a736c': `Folksonomia Motorraren Dokumentazioa`,
's383ae4449428b61e': `Berrezarri mozketa`,
's39bcf88721a1e8ee': `Berrezarri hautaketa`,
's39e14e14300694c7': `Dokumentazioa eta Jarraibideak`,
's3b430cfa5c1fe7f4': str`${0}-ren dokumentazioa`,
's3f4e4b52f230a892': `Irudi-oihal`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Balioa`,
's422bba9636ce2489': `Erdiko irudia`,
's42dd66b2441566fd': `Erdiko ikonoa`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Gehitu mantenugai bat`,
's453ab0dbb9b5c777': `Eskuinera tamaina aldatu`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Produktu kopurua`,
's4df2f533c0c1e7d0': `Irudien kontrolak`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Mugitu hautaketa`,
's4f751fb9b3ed766c': `Jabetza berri bat sortzea`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Sartu jabetzaren izena...`,
's55d7249883a98ca1': `jabetza honi buruz Open Food Facts wikian`,
's565867d84c04aea2': `Iragazkiaren propietateak...`,
's5666afe5cd0166de': `Mesedez, konpondu akatsak edo aldatu testua baieztatu aurretik.`,
's57472465a23b41db': `Balioak`,
's58e1eeea7a60ae51': `Produktuak kargatzen...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Lagundu iezaguzu nutrizio-informazioa zuzentzen.`,
's5dd6f12783fca34f': `Osagaien zerrenda editatu`,
's5e8250fb85d64c23': `Itxi`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Editatu`,
's66413c24dcf680e2': `Saltatu`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Moztutako irudia`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Bat etortze ona ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Dokumentazioa`,
's787dd11bed0dc88a': `Ezkerretara tamaina aldatu`,
's7ce4fd9430e80cea': `balioa`,
's801a05fa8e881f37': `Lortu informazio gehiago jabetza sortzeari eta jarraibideei buruz:`,
's8038273de2cf8b73': `Mesedez, hautatu moztu nahi duzun eskualdea.`,
's839cc2908a5387f2': `Iragazi barra-kodeak...`,
's86197dcf3e96af64': `Arakatu eta bilatu dauden propietateak`,
's8a63be30a129a59c': `Beheko tamaina aldatu`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Goiko eskuineko tamaina aldatu`,
's8db84aa4bc949af2': `Dokumentatu jabetza berria`,
's8f839a03997a16d7': `Ikusi produktua`,
's901ae1e236ac45d3': `Ezeztatu ezabatzea`,
's907f7a97c6b29425': `Kontuan izan datu-eredua alda daitekeela. Erabili zure ardurapean.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Osagaiak:`,
's9a7f60fce090ecaf': `Ez da propietateak kargatu. Saiatu berriro geroago.`,
's9b87abd68fb9df45': `Ez da aurkitu? Sortu giltza berria {value}`,
's9c0f52425fd2f07e': `Baliteke bat ez etortzea`,
's9fc41f789c63b40d': `Produktuak`,
'sa1fa766e0d5634d7': `Ez dago puntuaziorik eskuragarri`,
'sa548778b24054030': `Arakatu Folksonomy Engine proiektutik ekarpenak egin diren propietate guztiak. Propietate hauek Open Food Facts datu-baseko produktuei buruzko metadatu eta informazio gehigarria eskaintzen dute.`,
'sa63907958bd0ec4b': `Goiko ezkerreko tamaina aldatu`,
'sa95b4224f685a36a': `Itxi modala`,
'sab56a1d439576fd6': `Iradokizunaren ikonoa`,
'sac47ea2901d04c15': `Aldatu beheko ezkerreko tamaina`,
'sb125227d436c2925': `Bilatu zure jabetzaren kontzeptua dauden jabetza-datu-basean:`,
'sb125568d43642e6f': `Produktuari buruzko galderak erantzun.`,
'sb1c538e038f9b214': str`Oso Parekatze Ona ${0}%`,
'sb28639570ff3b852': `propietate guztien zerrenda`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Zure jabetza existitzen ez dela eta komunitateak erabilgarria dela onartzen duenean egiaztatu ondoren, lehenik wikian dokumentatu behar duzu.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Ez da produkturik aurkitu propietate honetarako.`,
'sb7f72e4c8a2d3357': `Iragazi balioak...`,
'sb8178320160f84ea': `Erakutsi mozketa`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Galdera guztiei erantzun zaie! Eskerrik asko laguntzagatik!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Dagokion balioa`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Goiko tamaina aldatu`,
'sc1c08d0cbcc3bd24': `Ez dator bat`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Konponketa iradokia`,
'sc681b137e8f604f7': `Berretsi ezabatzea`,
'sc6daf8a31883f8b9': `Mugitu irudia`,
'sc895972c88d38ca5': `Folksonomia jabetza`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Lerroak`,
'scb3b0671d7b7f640': `Balio berria`,
'scb489a1a173ac3f0': `Bai`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Batu zaitez Slack eztabaidara`,
'scdb6cad0b92721bf': `Ez da propietaterik aurkitu.`,
'scf23a05631f93732': `Berretsi ezabatzea`,
'scfed2f270ef6a3aa': `Hautatu eremua`,
'sd1022bc1ef9204f7': `Irudi zoomagarria`,
'sd1077c055cf9ba6b': `Lagundu iezaguzu produktuaren osagaien zerrenda balioztatzen.`,
'sd698d21ddecba56b': `Kaixo! Produktuaren informazioa hobetzen lagun diezagukezu honako atal hauei erantzunez:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Egiaztatu jabetza bat dagoeneko existitzen den ala ez`,
'sdbf806fefc584115': `Aurkitu beharko zenuke bat`,
'sdc673e73b5c13aea': `Ezabatu`,
'sdc792b75f1edcaba': `Lagundu iezaguzu osagaien ortografia zuzentzen.`,
'sdca5deead576ceee': `Aldatu beheko eskuineko tamaina`,
'sdcc2555c5dde524f': `Ziur zaude elementu hau ezabatu nahi duzula? Ekintza hau ezin da desegin.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Baliogabetu`,
'se5127cf0f92e7e48': `Aholkua: hau ere aurki dezakezu`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Uzta hobea proposatuko dut`,
'seea3800e27baa686': `Banakako produktuak`,
'sefaba4adc4ec9219': `Folksonomia Ezaugarriak`,
'seffa8ca49175b5f0': `Pertsonalizatutako propietateak`,
'sf44a6b3b232c28ea': str`Ordeztu uneko balioa ${0}-rekin`,
'sf4cd86a2f5ef2588': `Produktuaren barra-kodea`,
'sf57a61152168cc81': `Lagundu iezaguzu osagaien detekzioa zuzentzen`,
'sf88b90b8ba23871c': `Bat etortze ezezaguna`,
'sf9aee319a006c9b4': `Gehitu`,
'sfacbbe968fa7d773': `Jabetzaren izena:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Dagokion balioa`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  